<template>
    <div>
        <!--导航栏 start-->
        <!-- <van-nav-bar title="交易汇总" left-text="返回" @click-left="onClickLeft" left-arrow fixed>
        </van-nav-bar> -->
        <!--通过插槽自定义导航栏右侧的内容 end-->
        <!--导航栏  end-->
        <!-- 菜单 -->
        <div class="menu-data">
            <div class="menu-list">
                <div class="menu-list-item" :class="type == 1 ? 'active' : ''" @click="getListHandel(1)">交易流水</div>
                <div class="menu-list-item" :class="type == 2 ? 'active' : ''" @click="getListHandel(2)">交易汇总</div>
                <div class="menu-list-item" :class="type == 3 ? 'active' : ''" @click="getListHandel(3)">交易日报</div>
            </div>

            <div class="list">
                <!-- 交易流水 -->
                <div class="list-top" v-if="type == 1">
                    <!-- 时间选择 -->
                    <div style="display: flex;align-items: center;">
                        <!-- 开始时间 -->
                        <div @click="showPopFn()">
                            <div v-if="timeValue">{{ timeValue }}</div>
                            <div v-else>开始时间</div>
                        </div>
                        <van-popup v-model="show" position="bottom" :style="{ height: '40%' }">
                            <van-datetime-picker v-model="currentDate" type="date" title="选择日期" @confirm="confirmFn()"
                                @cancel="cancelFn()" />
                        </van-popup>
                        <!-- 横线 -->
                        <div style="margin: 0.2rem;">-</div>
                        <!-- 结束时间 -->
                        <div @click="showPopFn1()">
                            <div v-if="timeValue1">{{ timeValue1 }}</div>
                            <div v-else> 结束时间</div>
                        </div>
                        <van-popup v-model="show1" position="bottom" :style="{ height: '40%' }">
                            <van-datetime-picker v-model="currentDate1" type="date" title="选择日期" @confirm="confirmFn1()"
                                @cancel="cancelFn1()" />
                        </van-popup>
                    </div>
                    <!-- 商户选择 -->
                    <div>
                        <van-dropdown-menu>
                            <van-dropdown-item ref="items" :title="merchant_id == '' ? '全部商户' : merchant_name">
                                <div style="height: 10rem;overflow-y: auto;">
                                    <van-cell @click="pagexmer()" title="全部商户" is-link />
                                    <div v-for="(bububu, index) in option2" :key="index">
                                        <van-cell @click="outletmer(bububu.value, bububu.label)" :title="bububu.label"
                                            is-link />
                                    </div>
                                </div>
                            </van-dropdown-item>
                        </van-dropdown-menu>
                    </div>
                    <!-- 门店选择 -->
                    <div>
                        <van-dropdown-menu>
                            <van-dropdown-item ref="item" :title="store_id == '' ? '全部门店' : store_name"
                                style="overflow-y:auto;">
                                <van-cell @click="pagex()" title="全部门店" is-link />
                                <div v-for="(bububu, index) in option1" :key="index">
                                    <van-cell @click="outlet(bububu.value, bububu.label)" :title="bububu.label"
                                        is-link />
                                </div>
                            </van-dropdown-item>
                        </van-dropdown-menu>
                    </div>
                </div>
                <!-- 交易汇总 -->
                <div class="list-top" v-if="type == 2">
                    <!-- 时间选择 -->
                    <div style="display: flex;align-items: center;">
                        <!-- 开始时间 -->
                        <div @click="showPopFn()">
                            <div v-if="timeValue">{{ timeValue }}</div>
                            <div v-else>开始时间</div>
                        </div>
                        <van-popup v-model="show" position="bottom" :style="{ height: '40%' }">
                            <van-datetime-picker v-model="currentDate" type="date" title="选择日期" @confirm="confirmFn()"
                                @cancel="cancelFn()" />
                        </van-popup>
                        <!-- 横线 -->
                        <div style="margin: 0.2rem;">-</div>
                        <!-- 结束时间 -->
                        <div @click="showPopFn1()">
                            <div v-if="timeValue1">{{ timeValue1 }}</div>
                            <div v-else> 结束时间</div>
                        </div>
                        <van-popup v-model="show1" position="bottom" :style="{ height: '40%' }">
                            <van-datetime-picker v-model="currentDate1" type="date" title="选择日期" @confirm="confirmFn1()"
                                @cancel="cancelFn1()" />
                        </van-popup>
                    </div>
                    <!-- 商户选择 -->
                    <div>
                        <van-dropdown-menu>
                            <van-dropdown-item ref="items" :title="merchant_id == '' ? '全部商户' : merchant_name">
                                <div style="height: 10rem;overflow-y: auto;">
                                    <van-cell @click="pagexmer()" title="全部商户" is-link />
                                    <div v-for="(bububu, index) in option2" :key="index">
                                        <van-cell @click="outletmer(bububu.value, bububu.label)" :title="bububu.label"
                                            is-link />
                                    </div>
                                </div>
                            </van-dropdown-item>
                        </van-dropdown-menu>
                    </div>
                    <!-- 门店选择 -->
                    <div style="width: 100px;">
                        <!-- <van-dropdown-menu>
                            <van-dropdown-item ref="item" :title="store_id == '' ? '全部门店' : store_name"
                                style="overflow-y:auto;">
                                <van-cell @click="pagex()" title="全部门店" is-link />
                                <div v-for="(bububu, index) in option1" :key="index">
                                    <van-cell @click="outlet(bububu.value, bububu.label)" :title="bububu.label"
                                        is-link />
                                </div>
                            </van-dropdown-item>
                        </van-dropdown-menu> -->
                    </div>
                </div>
                <!-- 交易日报 -->
                <div class="list-top" v-if="type == 3">
                    <!-- 选择商户 -->
                    <div>
                        <van-dropdown-menu>
                            <van-dropdown-item ref="items" :title="merchant_id == '' ? '全部商户' : merchant_name">
                                <div style="height: 13rem;overflow-y: auto">
                                    <van-cell @click="pagexmer()" title="全部商户" is-link />
                                    <div v-for="(bububu, index) in option2" :key="index">
                                        <van-cell @click="outletmer(bububu.value, bububu.label)" :title="bububu.label"
                                            is-link />
                                    </div>
                                </div>
                            </van-dropdown-item>
                        </van-dropdown-menu>
                    </div>
                    <!-- 日周月报表 -->
                    <div class="report-type">
                        <div :class="forms == 'day' ? 'active-report' : ''" @click="reportHandel('day')">日报表</div>
                        <div :class="forms == 'week' ? 'active-report' : ''" @click="reportHandel('week')">周报表</div>
                        <div :class="forms == 'month' ? 'active-report' : ''" @click="reportHandel('month')">月报表</div>
                    </div>
                </div>
            </div>
            <!-- 列表数据 -->
            <div class="list-data">
                <!-- 交易流水 -->
                <van-list v-if="type == 1" class="list-data" v-model="loading" :finished="finished"
                    finished-text="没有更多了" @load="onLoad">
                    <div v-for="(admin, index) in list" :key="index">
                        <van-cell @click="to_transaction_details(admin.pay_id)">
                            <van-row gutter="20">
                                <van-col span="13">
                                    <van-row gutter="20">
                                        <van-col span="24" class="title_font">{{ admin.trans_subject }}</van-col>
                                        <van-col span="24" class="date_font">{{ admin.trans_oktime }}</van-col>
                                    </van-row>
                                </van-col>
                                <van-col span="7">
                                    <van-row gutter="20">
                                        <van-col span="24" class="title_font">{{ admin.trans_type == "wxpay" ? "微信" :
                    (admin.trans_type == "alipay" ? "支付宝" : "云闪付") }}</van-col>
                                        <van-col span="24" class="title_font">￥{{ admin.total_fee }}</van-col>

                                    </van-row>
                                </van-col>
                                <van-col span="4" :class="admin.trans_status == 3 ? 'green_like' : 'green_font'"
                                    class="green_font">{{ admin.trans_status == 3 ? "退款" : "成功" }}</van-col>
                            </van-row>
                        </van-cell>
                    </div>
                </van-list>
                <!-- 交易汇总 -->
                <div v-if="type == 2">
                    <van-grid :column-num="3" :border="false" id="vat_grid">
                        <van-grid-item text="所属门店" />
                        <van-grid-item text="交易笔数" />
                        <van-grid-item text="交易金额" />
                    </van-grid>
                    <van-list class="list-data" v-model="loading" :finished="finished" finished-text="没有更多了"
                        @load="onLoad">
                        <div v-for="(admin, index) in list" :key="index">
                            <van-grid :column-num="3" :border="false">
                                <van-grid-item style="text-align:center " :text="admin.store_name" />
                                <van-grid-item :text="admin.total_num + '笔'" />
                                <van-grid-item :text="admin.total_fee + '元'" />
                            </van-grid>
                        </div>
                    </van-list>
                </div>
                <!-- 交易日报 -->
                <div v-if="type == 3">
                    <van-grid :column-num="3" :border="false" id="vat_grid">
                        <van-grid-item text="交易时间" />
                        <van-grid-item text="交易笔数" />
                        <van-grid-item text="交易金额" />
                    </van-grid>
                    <van-list class="list-data" v-model="loading" :finished="finished" finished-text="没有更多了"
                        @load="onLoad">
                        <div v-for="(admin, index) in list" :key="index">
                            <van-grid :column-num="3" :border="false">
                                <van-grid-item :text="admin.date" />
                                <van-grid-item :text="admin.summary_collest_count + '笔'" />
                                <van-grid-item :text="admin.summary_collest +'元'" />
                            </van-grid>
                        </div>
                    </van-list>
                </div>
            </div>
        </div>
        <!--内容 end-->
    </div>
</template>

<script>
export default {
    name: "AgentMerchantCollect", //交易汇总
    data() {
        return {
            type: 1, // 默认交易流水
            forms: "day", //默认日报表 
            list: [],
            loading: false,
            finished: false,
            //下拉选择
            value1: 0,
            option1: [],
            option2: [],
            //时间选择
            msg: '',
            currentDate: new Date(),
            currentDate1: new Date(),
            show: false, // 用来显示弹出层
            show1: false, // 用来显示弹出层
            timeValue: '',
            timeValue1: "",
            page: 0,
            num: 10,
            // 门店id
            store_id: '',
            merchant_id: '',
            store_name: '',
            merchant_name: "",
        };
    },
    mounted() {
        this.timeFormat(new Date());
        //获取当前日期
        this.getData()
        //商户列表信息
        this.theMerchants()
    },
    methods: {
        //切换交易类型
        getListHandel(val) {
            this.type = val;
            this.store_id = '';
            this.merchant_id = '';
            this.page = 0;
            this.list = []
            this.getData()
            this.onLoad()
        },

        // 跳转至单笔订单明细
        to_transaction_details(pay_id) {
            this.$router.push({ path: '/TransactionDetails', query: { jobId: pay_id } })
        },

        //点击报表类型
        reportHandel(active) {
            this.forms = active
            this.page = 0
            this.list = []
            this.onLoad()
        },

        //选择某个门店
        outlet(a, b) {
            this.store_id = a;
            this.store_name = b;
            this.$refs.item.toggle();
            this.page = 0;
            this.list = []
            this.onLoad()
        },
        //选择某个商户
        outletmer(a, b) {
            this.merchant_id = a;
            this.merchant_name = b;
            this.$refs.items.toggle();
            this.store_id = '';
            this.theStores()
            this.page = 0;
            this.list = []
            this.onLoad()
        },

        // 点击下拉菜单 选择全部门店
        pagex() {
            this.store_id = "";
            this.page = 0;
            this.list = [];
            //控制下拉菜单收起
            this.$refs.item.toggle();
            this.onLoad()
        },
        // 点击下拉菜单 选择全部商户
        pagexmer() {
            this.merchant_id = "";
            this.store_id = '';
            this.option1 = [];
            this.page = 0;
            this.list = [];
            //控制下拉菜单收起
            this.$refs.items.toggle();
            this.onLoad()
        },

        //获取全部的商户
        theMerchants() {
            this.$http.get('/wechat/api.agent.pay/merchants').then(response => {
                this.option2 = response.data.data
            })
        },

        //全部门店列表
        theStores() {
            this.$http.get('/wechat/api.agent.pay/stores', {
                params: {
                    merchant_id: this.merchant_id
                }
            }).then(response => {
                this.option1 = response.data.data
            })
        },

        // 获取当前日期年月日
        getData() {
            var currentDate = new Date();
            // 获取年份
            var year = currentDate.getFullYear();
            // 获取月份（注意：月份从 0 开始，所以要加 1）
            var month = currentDate.getMonth() + 1;
            // 获取日期
            var day = currentDate.getDate();
            this.timeValue = year + '-' + month + '-' + day;
            this.timeValue1 = year + '-' + month + '-' + day;
        },

        // 页面初始化的时候确定当前的日期
        addDate() {
            let nowDate = new Date()
            let date = {
                year: nowDate.getFullYear(),
                month: nowDate.getMonth() + 1,
                date: nowDate.getDate()
            }
            if (this.$store.state.time != "" && this.$store.state.time1 == "") {
                this.timeValue = this.$store.state.time
                this.timeValue1 = date.year + '-' + date.month + '-' + date.date
            } else if (this.$store.state.time == "" && this.$store.state.time1 != "") {
                this.timeValue = date.year + '-' + date.month + '-' + date.date
                this.timeValue1 = this.$store.state.time1
            } else if (this.$store.state.time != "" && this.$store.state.time1 != "") {
                this.timeValue = this.$store.state.time
                this.timeValue1 = this.$store.state.time1
            } else if (this.$store.state.time == "" && this.$store.state.time1 == "") {
                this.timeValue = date.year + '-' + date.month + '-' + date.date,
                    this.timeValue1 = date.year + '-' + date.month + '-' + date.date
            }

        },

        // 时间选择
        showPopFn() {
            this.show = true;
        },
        showPopFn1() {
            this.show1 = true;
        },
        showPopup() {
            this.show = true;
        },
        showPopup1() {
            this.show = true;
        },

        // 选择开始日期确定按钮
        confirmFn() {
            this.timeValue = this.timeFormat(this.currentDate);
            this.$store.commit("timer", this.timeValue)
            this.show = false;
            this.page = 0;
            this.list = []
            this.onLoad()
        },
        // 选择结束日期确定按钮
        confirmFn1() {
            this.timeValue1 = this.timeFormat(this.currentDate1);
            this.$store.commit("timer1", this.timeValue1)
            this.show1 = false;
            this.page = 0;
            this.list = []
            this.onLoad()
        },
        cancelFn() {
            this.show = false;
        },
        cancelFn1() {
            this.show1 = false;
        },

        // 时间格式化
        timeFormat(time) {
            let year = time.getFullYear();
            let month = time.getMonth() + 1;
            let day = time.getDate();
            return year + '-' + month + '-' + day + ''
        },

        // 左侧返回
        onClickLeft() {
            this.$router.push("/AgentHomepage");
        },
        // 右侧icon跳转至订单查询
        // onClickRight() {
        //     // 跳转至订单查询
        //     this.$router.push('/TransactionSearch');
        // },
        // 列表
        onLoad() {
            // 异步更新数据
            this.page += 1;
            this.tive()
        },

        //根据选择发送请求
        tive() {
            var that = this
            if (that.type == 1) {
                this.$http.get('/wechat/api.order/get_order', {
                    params: {
                        // merchant_id: window.sessionStorage.getItem("commercialId"),
                        agent_id: window.sessionStorage.getItem("agent_id"),
                        merchant_id: that.merchant_id,
                        store_id: that.store_id,
                        start_date: that.timeValue,
                        end_date: that.timeValue1,
                        page: that.page,
                        num: that.num
                    }
                }).then(response => {
                    that.loading = false;
                    if (response.data.data.length) {
                        that.list.push(...response.data.data);
                        that.finished = false;
                    } else {
                        that.finished = true;
                    }
                })
            } else if (that.type == 2) {
                this.$http.get('/wechat/api.agent.pay/statistics', {
                    params: {
                        merchant_id: that.merchant_id,
                        beginTime: that.timeValue,
                        store_id: that.store_id,
                        endTime: that.timeValue1,
                        pageSize: that.num,
                        pageNum: that.page
                    }
                }).then(response => {
                    that.loading = false;
                    if (response.data.data.rows.length) {
                        that.list.push(...response.data.data.rows);
                        that.finished = false;
                    }
                    if (response.data.data.rows.length < that.num) {
                        that.finished = true;
                    }
                })
            } else if (that.type == 3) {
                this.$http.get('/wechat/api.agent.pay/getStoreStatistics', {
                    params: {
                        merchant_id: that.merchant_id,
                        store_id: that.store_id,
                        type: that.forms,
                        pageNum: that.page,
                        pageSize: that.num
                    }
                }).then(response => {
                    that.loading = false;
                    if (response.data.rows.length) {
                        that.list.push(...response.data.rows);
                        that.finished = false;
                    }
                    if (response.data.rows.length < that.num) {
                        that.finished = true;
                    }
                })
            }
        },
    },
}
</script>

<style scoped>
.active {
    background-color: rgba(18, 118, 221, 0.9);
}

.active-report {
    font-weight: 700;
    color: rgb(20, 134, 251);
}

.title_font {
    color: #535353;

}

.title_font1 {
    color: #535353;
    position: relative;
    top: 0.33rem;

}

.date_font {
    color: #919191;
}

.green_font {
    color: #4cd964;
    line-height: 48px;
}

.green_like {
    color: red;
    line-height: 48px;
}

.van-menu {
    display: flex;
    justify-content: space-between;
}

.van-menu-item {
    width: 64%;
    display: flex;

}

.div-hr {
    background-color: white;
    height: 1.27rem;
}

hr {
    margin-top: 0.65rem;
    width: 0.4rem;
    background-color: white;
}

.dropdown-menu {
    width: 43%;

}

.dropdown-menus {
    width: 100%;
}

.menu-data {
    width: 100%;
    height: 200px;
    box-sizing: border-box;
    padding: 16px;
    background-color: rgba(20, 134, 251, 1);
}

.menu-list {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 241px;
    height: 26px;
    background-color: rgba(255, 255, 255, 0.3);
    border-radius: 16px;
    font-size: 12px;
    color: #FFFFFF;
}

.menu-list-item {
    text-align: center;
    width: 80px;
    height: 26px;
    line-height: 26px;
    border-radius: 16px;
}

.list {
    width: 100%;
    box-sizing: border-box;
    padding: 0 16px;
    height: 40px;
    margin-top: 10px;
    background-color: rgba(255, 255, 255, 1);
    box-sizing: border-box;
    border-radius: 12px;
    border-bottom-right-radius: 0px;
    border-bottom-left-radius: 0px;
    border-bottom: 1px solid rgba(215, 215, 215, 1);
}

.list-top {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    color: #333333;
}

.list-data {
    width: 100%;
    height: calc(100vh - 180px);
    overflow-y: auto;
    background-color: #fff;
}

.report-type {
    width: 40%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    color: #333333;
}
</style>
<style scoped="scoped">
.van-field__control {
    position: relative;
    top: 0.1rem;
}

.van-popup {
    overflow-y: hidden !important;
}

.van-dropdown-menu__title::after {
    /* border: none!important; */
}

.list-top /deep/ .van-dropdown-menu__bar {
    box-shadow: none !important;
    height: 30px !important;
}

.list-top /deep/ .van-dropdown-menu__title {
    font-size: 12px;
    color: #333333;
    max-width: none;
    max-width: 70px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>
